import { Link, useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

// Mirrors apps/mobile/app/(auth)/community-guidelines.tsx. Same copy.

export function CommunityGuidelinesPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-full bg-navy text-white">
      <div className="px-4 pt-8 pb-4 flex items-center justify-between max-w-3xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-gold p-1" aria-label="Back">
          <ChevronLeft size={24} />
        </button>
        <h1 className="text-gold text-xl font-extrabold">jnati</h1>
        <div className="w-8" />
      </div>
      <div className="max-w-3xl mx-auto px-6 pb-12">
        <h2 className="text-gold text-2xl font-extrabold text-center mt-4 mb-5">Community Guidelines</h2>

        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          At Jnati, we aim to build a respectful, inclusive, and family-friendly environment.
          These Community Guidelines ensure that all users feel safe and welcome.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">1. Be Respectful</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Treat all users with kindness, dignity, and respect. Do not post comments, photos, or
          messages that are hateful, threatening, or discriminatory.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">2. Stay Truthful</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Build relationships truthfully. Do not impersonate someone else, post fake
          information, or create deceptive profiles or relatives.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">3. Share Responsibly</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Share only content that is suitable for a family-oriented network. Avoid posting
          private information about others without their consent.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">4. Report Abuse</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          If you encounter harmful behavior or content, report it immediately via the platform
          or by emailing support@jnati.com.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">5. Consequences</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Violation of these guidelines may result in warnings, content removal, or account
          suspension at our discretion.
        </p>

        <div className="text-center mt-10">
          <Link to="/login" className="text-gold underline text-[15px]">← Back to Login</Link>
        </div>
      </div>
    </div>
  )
}
